export default __webpack_public_path__ + "static/media/our-features.ed676656.png";